import { CollapseProps } from 'antd'
import { Default } from './collapse.default'
import { Attachment } from './collapse.attachment'

const Collapse = (props: CollapseProps) => <Default {...props} />

Collapse.Default = Default
Collapse.Attachment = Attachment

export default Collapse
